import {css} from "styled-components"

export const mainStyles = css`
  ${({theme}) => `
    font-family: ${theme.font.medium};
    color: ${theme.colors.utility.ink};
  `}
`

export const largeStyles = css`
  font-size: 16px;
  line-height: 24px;
`

export const regularStyles = css`
  font-size: 12px;
  line-height: 24px;
  letter-spacing: 0;
`
